import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useLanguage } from '../../context/LanguageContext';
import { Play, ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';

export function HeroSection() {
  const { isAuthenticated } = useAuth();
  const { t } = useLanguage();

  return (
    <section className="hero-bg min-h-screen flex items-center pt-32" style={{
      backgroundImage: `url('https://images.unsplash.com/photo-1762279389042-9439bfb6c155?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxkYXJrJTIwYWJzdHJhY3QlMjB0ZWNobm9sb2d5JTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3NzUzMjg5NTR8MA&ixlib=rb-4.1.0&q=85')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }}>
      <div className="hero-content max-w-7xl mx-auto px-6 py-24">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="animate-fade-in-up">
            <div className="inline-flex items-center gap-2 bg-[#007AFF]/10 border border-[#007AFF]/30 rounded-sm px-4 py-2 mb-6">
              <span className="w-2 h-2 bg-[#00FF66] rounded-full animate-pulse"></span>
              <span className="text-[#007AFF] text-sm font-medium">{t('landing.heroTag')}</span>
            </div>
            
            <h1 className="text-5xl lg:text-7xl font-black tracking-tight text-white mb-6" style={{ fontFamily: 'Chivo, sans-serif' }}>
              {t('landing.heroTitle')}
              <span className="block text-[#007AFF]">{t('landing.heroTitleHighlight')}</span>
            </h1>
            
            <p className="text-lg text-[#A1A1AA] mb-8 max-w-lg">
              {t('landing.heroDescription')}
            </p>
            
            <div className="flex flex-wrap gap-4">
              <Link to="/register">
                <Button className="btn-primary flex items-center gap-2" data-testid="hero-cta-btn">
                  {t('landing.startLearning')} <ArrowRight className="w-4 h-4" />
                </Button>
              </Link>
              <a href="#courses">
                <Button className="btn-secondary flex items-center gap-2" data-testid="view-courses-btn">
                  <Play className="w-4 h-4" /> {t('landing.viewCourses')}
                </Button>
              </a>
            </div>
            
            <div className="flex items-center gap-8 mt-12">
              <div>
                <div className="text-3xl font-bold text-white font-mono">2,500+</div>
                <div className="text-[#71717A] text-sm">{t('landing.activeStudents')}</div>
              </div>
              <div className="w-px h-12 bg-[#27272A]"></div>
              <div>
                <div className="text-3xl font-bold text-white font-mono">94%</div>
                <div className="text-[#71717A] text-sm">{t('landing.successRate')}</div>
              </div>
              <div className="w-px h-12 bg-[#27272A]"></div>
              <div>
                <div className="text-3xl font-bold text-white font-mono">$50M+</div>
                <div className="text-[#71717A] text-sm">{t('landing.studentProfits')}</div>
              </div>
            </div>
          </div>
          
          <div className="hidden lg:block animate-fade-in-up stagger-2">
            <div className="relative">
              <div className="absolute -inset-4 bg-[#007AFF]/10 rounded-md blur-3xl"></div>
              <div className="relative bg-[#141417] border border-[#27272A] rounded-md p-6">
                <div className="flex items-center justify-between mb-4">
                  <span className="text-[#71717A] text-sm">Live Performance</span>
                  <span className="text-[#00FF66] font-mono text-sm">+24.8%</span>
                </div>
                <div className="h-48 flex items-end gap-1">
                  {[40, 55, 45, 60, 50, 70, 65, 80, 75, 90, 85, 95].map((h, i) => (
                    <div key={`bar-${i}`} className="flex-1 bg-gradient-to-t from-[#007AFF] to-[#007AFF]/50 rounded-t-sm" style={{ height: `${h}%` }}></div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
